export const FormModeValues = {
    Form: "Form",
    Preview: "Preview",
} as const;

export type FormMode = (typeof FormModeValues)[keyof typeof FormModeValues];
